import * as React from 'react';
import type { SVGProps } from 'react';

const SvgSd = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" {...props}>
    <path d="M102 289.68v540h699.24c41.641 0 32.398 20.879 51 20.879s43.922 16.199 60 0 20.879 24 53.281 7.2c32.398-16.802 41.641-12 60 4.077 18.359 16.078 39.359 48.961 48.602 48.961 9.238 0 19.68-7.558 12-24-7.68-16.438-11.641-22.797-6.121-34.797s19.078-25.44 15.12-36c-3.96-10.559 9.24-8.64-1.8-33.48-11.039-24.84-16.8-19.199-17.879-27.84-1.078-8.64 0-18.48 2.281-19.68l12-6.36s3-310.8 1.2-319.56v-.003a69.87 69.87 0 0 0-25.441-30.117c-9.239-5.762-22.078 5.281-19.68-20.16s-8.16-19.199 16.8-37.68 13.32-24 13.32-27.84-1.199-3.48-12-3.48z" />
  </svg>
);
export default SvgSd;
